<app-pias-layout>
    <div pias-layout-content>
        <div id="dashboard-container" class="container-fluid">
            <div id="dashboard-header">
                <h5 class="page-header">Dashboard</h5>
            </div>

            <div id="dashboard-tabs-container">
                <mat-card appearance="raised">
                    <mat-card-content>
                        <mat-tab-group (selectedTabChange)="this.__onDashboardTabChange($event)">
                            <mat-tab label="Incepted APE" id="incepted-ape">
                                @if(this.selectedTabId === "incepted-ape") {
                                <div class="dashboard-tab-content">
                                    <dashboard-incepted-ape></dashboard-incepted-ape>
                                </div>
                                }
                            </mat-tab>
                            @if(!this.isAffinityUser()) {
                            <mat-tab label="Gross Revenue" id="gross-revenue">
                                @if(this.selectedTabId === "gross-revenue") {
                                <div class="dashboard-tab-content">
                                    <dashboard-gross-revenue></dashboard-gross-revenue>
                                </div>
                                }
                            </mat-tab>
                            <mat-tab label="Convention" id="convention">
                                @if(this.selectedTabId === "convention") {
                                <div class="dashboard-tab-content">
                                    <dashboard-pias-convention></dashboard-pias-convention>
                                </div>
                                }
                            </mat-tab>
                            }
                            <mat-tab label="MDRT Status" id="mdrt-status">
                                @if(this.selectedTabId === "mdrt-status") {
                                <div class="dashboard-tab-content">
                                    <dashboard-mdrt-status></dashboard-mdrt-status>
                                </div>
                                }
                            </mat-tab>
                        </mat-tab-group>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</app-pias-layout>>